// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__Cn9lK","goRoundAndRound":"Loading_goRoundAndRound__V7pi_"};